import { useQuery } from "@tanstack/react-query";

import { env } from "../config/env";
import { get } from "./client";
import type { ApiResponse } from "./deals";
import { queryKeys } from "./queryKeys";

export interface MappingReadinessCapability {
  eligible: boolean;
}

export type MappingReadinessReason = "document_processing" | "mapping_required" | "no_data";

export const MAPPING_READINESS_POLL_INTERVAL_MS = env.uiPollIntervalMs;

export interface MappingReadiness {
  hasActiveDeal: boolean;
  mappingComplete: boolean;
  mappingReason?: MappingReadinessReason | null;
  dealDataVersionId?: number | null;
  insights: MappingReadinessCapability;
  gapAnalysis: MappingReadinessCapability;
  day1Readiness: MappingReadinessCapability;
}

export async function getMappingReadiness(): Promise<MappingReadiness> {
  const response = await get<ApiResponse<MappingReadiness>>("/mapping-readiness");
  if (!response.success || response.data == null) {
    throw new Error(response.message ?? "Unable to load mapping readiness.");
  }
  return response.data;
}

export function useMappingReadiness(enabled = true, refetchIntervalMs?: number) {
  return useQuery({
    queryKey: queryKeys.api.mappingReadiness(),
    queryFn: getMappingReadiness,
    enabled,
    refetchInterval: refetchIntervalMs,
    staleTime: 5_000,
  });
}
